module.exports = "images/doc-currency-menu.4ecca7616ab22862dbcd9338026e823a.png";